export default __webpack_public_path__ + "static/media/Screenshot (1144).e207363f.png";